


// import created components  :
import Background from '../../components/background/Background.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />



function Error() { // full page as component imported in router


    return (
        <div className="bg-relative">
            <Background ind={2} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <div className="error">
                        <h3>Oups! le shore break...</h3>
                        <h1>erreur 404</h1>
                        <p>La page recherchée n'existe pas, ou vous avez décidé de prendre une vague qui vous a poussé directement sur le sable. Bref, erreur 404.</p>
                        <p>Rien de grave, vous pouvez <a href="/startresa">retourner à l'accueil.</a></p>
                    </div>

                </div>
            </main>
        </div>
    );
}

export default Error;